import React from 'react'
import { connect } from 'react-redux'
import { reduxForm, getFormValues } from 'redux-form'
import { Icon } from 'semantic-ui-react'
import ReactTable from 'react-table'

import { 
  purchaseOrderUpdateCreatePath,
  purchaseOrderUpdateEditPath,
  purchaseOrderUpdateDetailPath
} from 'routes'
import {
  columns
} from './AttributeData'
import { 
  fetchPOUpdateList
} from 'ducks/poUpdate'
import { 
  MainBodyContent, 
  CustomButton,
  SearchList,
  TablePagination
} from 'components'

import { POUListCont } from './styled'
import { ProcurementContainer, ProcurementBody } from '../styled'

const POUpdateList = (props) => {

  const { 
    pouList,
    valueForm 
  } = props

  const userPageSize = parseInt(localStorage.getItem('userPageSize') || '10')
  const [pageSize, setPageSize] = React.useState(userPageSize)

  React.useEffect(() => {
    props.fetchPOUpdateList({page:1,size:pageSize})
  },[])

  return (
    <MainBodyContent
      headerTitle="Update/Cancel Purchase Order"
      accessoriesHeader={
        <div style={{ display: 'flex' }}>
          <CustomButton
            onClick={() => props.history.push(purchaseOrderUpdateCreatePath)}
            icon="plus"
            btnColor="gray"
            title="Create"
          />
        </div>
      }
    >
      <ProcurementContainer>
        <ProcurementBody>
          <SearchList pageSize={pageSize} placeholder='PO Doc No., Title, Requester' fetchAPI={props.fetchPOUpdateList} formSearchName='formSearchPOUpdate' filterDate filterStatus/>
          <POUListCont>
            <ReactTable 
              data={Object.keys(pouList).length>0?pouList.data:[]}
              columns={columns.tPOUs}
              defaultPageSize={userPageSize}
              noDataText="No Request PO Update found"
              previousText={<Icon name="arrow alternate circle left" />}
              nextText={<Icon name="arrow alternate circle right" />}
              className="-striped -highlight"

              PaginationComponent={TablePagination}
              pages={Object.keys(pouList).length>0?pouList.totalPage:0}
              currentPage={Object.keys(pouList).length>0?pouList.page:0}
              onPageChange={(pageIndex) => {
                props.fetchPOUpdateList({...valueForm,page:pageIndex+1,size:pageSize})
              }}
              onPageSizeChange={(pageSize, pageIndex) => {
                setPageSize(pageSize)
                localStorage.setItem('userPageSize', pageSize)
                props.fetchPOUpdateList({...valueForm,page:pageIndex+1,size:pageSize})
              }}

              getTdProps={(state, rowInfo, column, instance) => {
                return {
                  onClick: (e, handleOriginal) => {
                    if (rowInfo && column && column.Header !== '') {
                      if ([0, 5, 1].indexOf(rowInfo.original.status) >= 0) {
                        window.open(purchaseOrderUpdateEditPath(rowInfo.original.id))
                      } else {
                        window.open(purchaseOrderUpdateDetailPath(rowInfo.original.id))
                      }
                    }
                    if (handleOriginal) {
                      handleOriginal()
                    }
                  },
                }
              }}
            />
          </POUListCont>
        </ProcurementBody>
      </ProcurementContainer>
    </MainBodyContent>
  )
}

const mapStateToProps = state => ({
  pouList: state.poUpdate.pouList,
  valueForm: getFormValues('formSearchPOUpdate')(state)
})

const mapDispatchToProps = {
  fetchPOUpdateList
}

const contForm = reduxForm({
  form: 'formSearchPOUpdate',
  enableReinitialize: true,
})(POUpdateList)

export default connect(mapStateToProps, mapDispatchToProps)(contForm)
